import { Suspense } from 'react';
import PageSpinner from '../components/shared/PageSpinner';
import FederatedHeader from './federatedHeader';
import type { IFederatedLayoutProps } from '../types/propTypes';

const FederatedLayout = ({ children, displayName }: IFederatedLayoutProps) => {
  return (
    <div className="wrapper">
      <FederatedHeader displayName={displayName} />
      <main className="main-content">
        <div className="container-xl">
          <div className="card mb-4">
            <Suspense fallback={<PageSpinner />}>{children}</Suspense>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FederatedLayout;
